function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { CloudinaryImage } from "../assets/CloudinaryImage.js";
import { CloudinaryVideo } from "../assets/CloudinaryVideo.js";

var Cloudinary = /*#__PURE__*/function () {
  function Cloudinary(cloudinaryConfig) {
    _classCallCheck(this, Cloudinary);

    if (cloudinaryConfig) {
      this.cloudinaryConfig = cloudinaryConfig;
    }
  }

  _createClass(Cloudinary, [{
    key: "image",
    value: function image(publicID) {
      return new CloudinaryImage(publicID, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
    }
  }, {
    key: "video",
    value: function video(publicID) {
      return new CloudinaryVideo(publicID, this.cloudinaryConfig.cloud, this.cloudinaryConfig.url);
    }
  }, {
    key: "setConfig",
    value: function setConfig(cloudinaryConfig) {
      this.cloudinaryConfig = cloudinaryConfig;
      return this;
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.cloudinaryConfig;
    }
  }, {
    key: "extendConfig",
    value: function extendConfig() {// Future implementation
    }
  }]);

  return Cloudinary;
}();

export { Cloudinary };